export function isYoutubeUrl(value: string) {
  try {
    const url = new URL(value)
    if (url.protocol !== "https:" || url.username || url.password || url.port)
      return false
    if (
      !["youtube.com", "www.youtube.com", "m.youtube.com", "youtu.be"].includes(
        url.hostname.toLowerCase()
      )
    )
      return false
    const id =
      url.hostname.toLowerCase() === "youtu.be"
        ? /^\/([^/]+)\/?$/.exec(url.pathname)?.[1]
        : url.pathname === "/watch"
          ? url.searchParams.get("v")
          : /^\/(?:shorts|live|embed)\/([^/]+)\/?$/.exec(url.pathname)?.[1]
    return Boolean(id && /^[A-Za-z0-9_-]{11}$/.test(id))
  } catch {
    return false
  }
}

export function isTwitchVodUrl(value: string) {
  try {
    const url = new URL(value)
    const authority = value.match(/^https:\/\/([^/?#]+)/i)?.[1] ?? ""
    return (
      url.protocol === "https:" &&
      !url.username &&
      !url.password &&
      !authority.includes(":") &&
      ["twitch.tv", "www.twitch.tv", "m.twitch.tv"].includes(
        url.hostname.toLowerCase()
      ) &&
      /^\/videos\/\d+\/?$/.test(url.pathname)
    )
  } catch {
    return false
  }
}

export function isSupportedVideoUrl(value: string) {
  return isYoutubeUrl(value) || isTwitchVodUrl(value)
}

export type VideoSourceSearch = { source?: string }

export function parseVideoSourceSearch(
  search: Record<string, unknown>
): VideoSourceSearch {
  const source = typeof search.source === "string" ? search.source.trim() : ""
  return source && source.length <= 4_096 ? { source } : {}
}
